// extracted by mini-css-extract-plugin
export default {"dealContainer":"OTDealOption_dealContainer__itIxA","buyVolume":"OTDealOption_buyVolume__e7Niu"};